import React from 'react';
import { Alert, Box, Button, Card, CardContent, Chip, Divider, Stack, Typography } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type Props = { scenarioCode?: string; summary?: any; objectiveGaps?: any[]; constraints?: any[]; onApplyScenario?: () => void };

class BieScenarioRecommendationPanel extends React.PureComponent<Props> {
  hasCritical() {
    return (this.props.objectiveGaps || []).some((x:any) => Number(x.targetvalue || 0) > 0 && Number(x.actualvalue || 0) / Number(x.targetvalue || 1) < 0.8);
  }

  render() {
    const critical = this.hasCritical();
    const constraints = this.props.constraints || [];
    return (
      <Card elevation={1}><CardContent>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box>
              <Typography variant="h6">Scenario Recommendation</Typography>
              <Typography variant="caption" color="text.secondary">Executive decision support for {this.props.scenarioCode || 'current scenario'}</Typography>
            </Box>
            <Chip icon={critical ? <AutoFixHighIcon /> : <CheckCircleIcon />} label={critical ? 'Review Needed' : 'Acceptable'} color={critical ? 'warning' : 'success'} />
          </Stack>
          <Alert severity={critical ? 'warning' : 'success'}>
            {critical ? 'Scenario has critical objective gaps. Review drivers before applying.' : 'Scenario is within acceptable objective tolerance.'}
          </Alert>
          <Divider />
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Constraint Alerts</Typography>
            {constraints.length === 0 ? (
              <Typography variant="body2" color="text.secondary">No constraint alerts detected for the current scenario.</Typography>
            ) : (
              <Stack spacing={1}>{constraints.map((x:any, i:number) => <Alert severity={x.severity || 'info'} key={x.code || i}>{x.message || x.description || JSON.stringify(x)}</Alert>)}</Stack>
            )}
          </Box>
          <Stack direction="row" justifyContent="flex-end">
            <Button variant="contained" startIcon={<CheckCircleIcon />} onClick={this.props.onApplyScenario} disabled={!this.props.onApplyScenario}>Apply Scenario</Button>
          </Stack>
        </Stack>
      </CardContent></Card>
    );
  }
}
export default BieScenarioRecommendationPanel;
